(function () {
    'use strict';

    /*global angular*/
    var app = angular.module('cccu.photoUpload', [
		'cccu.photoUpload.index',
		'cccu.photoUpload.instructions',
		'cccu.photoUpload.upload',
		'cccu.photoUpload.preview',
		'cccu.photoUpload.confirm',
		'cccu.photoUpload.success',
		'ui.router',
		'cccu.common.logging',
		'cccu.common.apiConfig',
        'cccu.common.currentStateName',
        'ui.bootstrap',
        'ngTouch',
        'ng.deviceDetector',
        'AppConfig'
    ]);

    app.config(['$httpProvider', function ($httpProvider) {
      
        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common['X-Requested-With'];
        
    }]);
      
    app.config(function ($stateProvider, $urlRouterProvider, $provide, $httpProvider) {
        $stateProvider.state('cccu.photoUpload', {
            data: {
                pageTitle: 'Photo Upload'
            }
        });
        $urlRouterProvider.otherwise('/');


    });

    app.run(function ($rootScope, $window, $log) {
        $rootScope.$on('$viewContentLoaded', function (event) {
            // force a resize event to happen, so that ombiel can play catchup. I believe that oMbiel 
            //$log.info('firing resize event for oMbiel.');
            $window.dispatchEvent(new Event('resize'));
        });
    });

    app.constant('uiText', {
        webApiUploadError: 'There was an error submitting your photo. Please contact the i-zone on 01227-782222.'
    });

}());
